module.exports = __webpack_public_path__ + "static/media/instructivooc5.cfa21eb5.png";